const Types = {
	CHANGE_PROJECT_SELECTED: 'CHANGE_PROJECT_SELECTED',
	CLEAR_ORGANIZATION: 'CLEAR_ORGANIZATION',
	SET_ORGANIZATION: 'SET_ORGANIZATION',
	SET_COMPANY: 'SET_COMPANY'
};

export default Types;
